import React, { useEffect, useState, useMemo } from "react";
import { SocialMedialogo } from "../../../../layout/DeepDive/DeepDivetab/SocialMediaPlatforms";
import Default_Brand from "../../../../../assets/brandLogos/Default_Brand.svg";
import Profile from "../../../../../assets/Profile_Pic.svg";
import verified from "../../../../../assets/verified.svg";
import BoostedPostIcon from "../../../../../assets/boosted_post_icon.svg";
import AdsPostIcon from "../../../../../assets/ads_post_icon.svg";
import ClockIcon from "../../../../../assets/Clock.svg";
import TreandsPieIcon from "../../../../../assets/Treands_Pie_Icon.svg";
import FollowersImage from "../../../../../assets/Followers_image.svg";
import Image from "antd/lib/image";
import Popover from "antd/lib/popover";
import Tooltip from "antd/lib/tooltip";
import { useSelector } from "react-redux";
import isEqual from "react-fast-compare";
import {
  postCardUserBrandCommentId,
  postCardUserbrandPrivateMessagesId,
} from "../../../../../redux/constants/enums";
import { updateVariableValueBasedOnThemeOrRoot } from "../../../../../features/DIYPersonalization/PersonalizationPreview/PersonalizationMapping";
import { getClass } from "../../../../../redux/constants";
const Header = ({
  cardData,
  animatedClass,
  activeClass,
  cardSlideClass,
  cardScaleDown,
  center,
  isCurrentSlide,
  index,
  isLeaderBoard,
  custom_card_settings,
  metadata,
  isDetailView,
  onClickHandleTrends,
}) => {
  const authParams = useSelector((state) => state?.Authentication?.authParams);
  const personalizationSettingsObj = useSelector(
    (state) => state?.PersonalizationSetting
  );
  const [headerOne, setHeaderOne] = useState([]);
  const [headerTwo, setHeaderTwo] = useState([]);
  const [headerThree, setHeaderThree] = useState([]);

  // dynamic text font for command center screen post gallery
  const bgColor = useMemo(() => {
    return postCardUserbrandPrivateMessagesId?.includes(cardData?.channel_type)
      ? "#F6F0FF"
      : cardData?.PlatformID == 1 &&
        cardData?.ParentSocialID !== "NA" &&
        cardData?.ParentSocialID != 0 &&
        cardData?.ParentSocialID !== ""
      ? "#E1F2FF"
      : postCardUserBrandCommentId?.includes(cardData?.channel_type) &&
        cardData?.PlatformID != 1
      ? "#E1F2FF"
      : "#FFF7E3";
  }, [cardData]); // Dependency array ensures it only recalculates when `cardData` changes.

  useEffect(() => {
    if (
      custom_card_settings?.card_header_1 &&
      Array.isArray(custom_card_settings?.card_header_1)
    ) {
      setHeaderOne(
        custom_card_settings?.card_header_1?.map((d) =>
          d?.attribute?.toLowerCase()
        )
      );
    }
    if (
      custom_card_settings?.card_header_2 &&
      Array.isArray(custom_card_settings?.card_header_2)
    ) {
      setHeaderTwo(
        custom_card_settings?.card_header_2?.map((d) =>
          d?.attribute?.toLowerCase()
        )
      );
    }
    if (
      custom_card_settings?.card_header_3 &&
      Array.isArray(custom_card_settings?.card_header_3)
    ) {
      setHeaderThree(
        custom_card_settings?.card_header_3?.map((d) =>
          d?.attribute?.toLowerCase()
        )
      );
    }
  }, [custom_card_settings]);
  const handleTrends = (trendData) => {
    if (personalizationSettingsObj?.isPersonalizationPreviewOpen) {
      return;
    }
    if (typeof onClickHandleTrends === "function" && onClickHandleTrends) {
      onClickHandleTrends(trendData);
    }
  };
  const getDefautBrandImg = (e) => {
    return (e.target.src = Default_Brand);
  };
  return (
    <>
      <div
        className={`gallarycard__header ${
          headerOne?.includes("sentimenttype") ? "sentiment-border" : ""
        } ${
          postCardUserbrandPrivateMessagesId?.includes(cardData?.channel_type)
            ? getClass(authParams, "message")
            : cardData?.PlatformID == 1 &&
              cardData?.ParentSocialID !== "NA" &&
              cardData?.ParentSocialID != 0 &&
              cardData?.ParentSocialID !== ""
            ? getClass(authParams, "comment")
            : postCardUserBrandCommentId?.includes(cardData?.channel_type) &&
              cardData?.PlatformID != 1
            ? getClass(authParams, "comment")
            : getClass(authParams, "post")
        }`}
        style={
          headerOne?.includes("sentimenttype")
            ? {
                borderLeftColor: `${
                  cardData?.SentimentType === "Positive"
                    ? "#5ED142"
                    : cardData?.SentimentType === "Negative"
                    ? "#FF5D48"
                    : cardData?.SentimentType === "Neutral"
                    ? "#F0C52F"
                    : "black"
                }`,
              }
            : {}
        }
      >
        {headerOne?.includes("rsmallimageurl") ||
        headerOne?.includes("brand_logo") ? (
          <>
            {cardData?.brand_logo &&
            cardData?.brand_logo !== "NA" &&
            cardData?.BrandFriendlyName &&
            cardData?.BrandFriendlyName !== "NA" &&
            cardData?.BrandFriendlyName !== "" ? (
              <Popover
                placement="leftBottom"
                title={null}
                content={
                  <div
                    style={{
                      maxWidth: "25rem",
                      maxHeight: "20rem",
                      overflow: "auto",
                    }}
                    className="text_regular fontSize-12 p-10"
                  >
                    {cardData?.BrandFriendlyName}
                  </div>
                }
                overlayClassName={
                  authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
                }
              >
                <Image
                  src={
                    cardData?.brand_logo ? cardData?.brand_logo : Default_Brand
                  }
                  fallback={
                    cardData?.brand_logo ? cardData?.brand_logo : Default_Brand
                  }
                  preview={false}
                  alt="Brand logo"
                  className="profileImg cursor-pointer border border-color"
                  style={{
                    width: "5rem",
                    height: "5rem",
                  }}
                  onError={getDefautBrandImg}
                  // crossOrigin="anonymous"
                />
              </Popover>
            ) : cardData?.BrandFriendlyName &&
              cardData?.BrandFriendlyName !== "NA" &&
              cardData?.BrandFriendlyName !== "" ? (
              <Popover
                placement="leftBottom"
                title={null}
                content={
                  <div
                    style={{
                      maxWidth: "25rem",
                      maxHeight: "20rem",
                      overflow: "auto",
                    }}
                    className="text_regular fontSize-12 p-10"
                  >
                    {cardData?.BrandFriendlyName}
                  </div>
                }
                overlayClassName={
                  authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
                }
              >
                <Image
                  src={
                    cardData?.brand_logo && cardData?.brand_logo !== "NA"
                      ? cardData?.brand_logo
                      : Default_Brand
                  }
                  fallback={
                    cardData?.brand_logo && cardData?.brand_logo !== "NA"
                      ? cardData?.brand_logo
                      : Default_Brand
                  }
                  preview={false}
                  alt="Brand logo"
                  onError={getDefautBrandImg}
                  className="profileImg cursor-pointer border border-color"
                  style={{
                    width: "5rem",
                    height: "5rem",
                  }}
                  // crossOrigin="anonymous"
                />
              </Popover>
            ) : (
              <Image
                src={
                  cardData?.brand_logo && cardData?.brand_logo !== "NA"
                    ? cardData?.brand_logo
                    : Default_Brand
                }
                fallback={
                  cardData?.brand_logo && cardData?.brand_logo !== "NA"
                    ? cardData?.brand_logo
                    : Default_Brand
                }
                preview={false}
                alt="Brand logo"
                onError={getDefautBrandImg}
                className="profileImg cursor-pointer border border-color"
                style={{
                  width: "5rem",
                  height: "5rem",
                }}
                // crossOrigin="anonymous"
              />
            )}
          </>
        ) : (
          ""
        )}
        {/* Old Code */}
        {/* {headerOne?.includes("picurl") ? (
          <>
            <div className="position-relative mr-15" style={{ width: "5rem" }}>
              {(cardData?.AuthorBio &&
                cardData?.AuthorBio !== "NA" &&
                cardData?.AuthorBio !== "") ||
              (cardData?.bio &&
                cardData?.bio !== "NA" &&
                cardData?.bio !== "") ? (
                <Popover
                  placement="leftBottom"
                  title={null}
                  content={
                    (cardData?.AuthorBio &&
                      cardData?.AuthorBio !== "NA" &&
                      cardData?.AuthorBio !== "") ||
                    (cardData?.bio &&
                      cardData?.bio !== "NA" &&
                      cardData?.bio !== "" && (
                        <div
                          style={{
                            maxWidth: "25rem",
                            maxHeight: "20rem",
                            overflow: "auto",
                          }}
                          className="text_regular fontSize-12 p-15 custom_scroll1"
                        >
                          {cardData?.AuthorBio
                            ? cardData?.AuthorBio
                            : cardData?.bio}
                        </div>
                      ))
                  }
                  overlayClassName={
                    authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
                  }
                >
                  <Image
                    src={
                      cardData?.picurl === 0 ||
                      cardData?.picurl === "" ||
                      !cardData?.picurl
                        ? Profile
                        : cardData?.picurl
                    }
                    fallback={Profile}
                    preview={false}
                    alt="Profile Images"
                    className="profileImg m-0 cursor-pointer"
                    style={{ width: "5rem", height: "5rem" }}
                    // crossOrigin={cardData?.picurl ? "" : "anonymous"}
                  />
                </Popover>
              ) : (
                <Image
                  src={
                    cardData?.picurl === 0 ||
                    cardData?.picurl === "" ||
                    !cardData?.picurl
                      ? Profile
                      : cardData?.picurl
                  }
                  fallback={Profile}
                  preview={false}
                  alt="Profile Images"
                  className="profileImg m-0 "
                  style={{ width: "5rem", height: "5rem" }}
                  // crossOrigin="anonymous"
                />
              )}
              {headerOne?.includes("socialmediaplatforms") ? (
                <div
                  className={
                    authParams?.screen_id === "000-000-557" &&
                    cardData?.isModalOpen
                      ? "read-more-channel-icon"
                      : "position-absolute"
                  }
                  style={{
                    right: "-0.8rem",
                    top: "-0.4rem",
                  }}
                >
                  <Image
                    src={
                      cardData?.PlatformID === 0 ||
                      cardData?.SocialMediaPlatforms === ""
                        ? Default_Brand
                        : cardData?.PlatformID
                        ? SocialMedialogo?.[cardData?.PlatformID]
                        : cardData?.SocialMediaPlatforms
                        ? SocialMedialogo?.[cardData?.SocialMediaPlatforms]
                        : Default_Brand
                    }
                    alt="Channel"
                    preview={false}
                    fallback={Default_Brand}
                    style={{
                      width: "2.6rem",
                      maxHeight: "2.6rem",
                      verticalAlign: "top",
                    }}
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          </>
        ) : (
          ""
        )} */}

        {/* New Code and Removed the pop over for bio on pic url, bcz we are show on side */}
        {headerOne?.includes("picurl") ? (
          <>
            <div className="position-relative mr-15" style={{ width: "5rem" }}>
              <Image
                src={
                  cardData?.picurl === 0 ||
                  cardData?.picurl === "" ||
                  !cardData?.picurl
                    ? Profile
                    : cardData?.picurl
                }
                fallback={Profile}
                preview={false}
                alt="Profile Images"
                className="profileImg m-0 "
                style={{ width: "5rem", height: "5rem" }}
                // crossOrigin="anonymous"
              />
              {headerOne?.includes("socialmediaplatforms") ? (
                <div
                  className={
                    authParams?.screen_id === "000-000-557" &&
                    cardData?.isModalOpen
                      ? "read-more-channel-icon"
                      : "position-absolute"
                  }
                  style={{
                    right: "-0.8rem",
                    top: "-0.4rem",
                  }}
                >
                  <Image
                    src={
                      cardData?.PlatformID === 0 ||
                      cardData?.SocialMediaPlatforms === ""
                        ? Default_Brand
                        : cardData?.PlatformID
                        ? SocialMedialogo?.[cardData?.PlatformID]
                        : cardData?.SocialMediaPlatforms
                        ? SocialMedialogo?.[cardData?.SocialMediaPlatforms]
                        : Default_Brand
                    }
                    alt="Channel"
                    preview={false}
                    fallback={Default_Brand}
                    style={{
                      width: "2.6rem",
                      maxHeight: "2.6rem",
                      verticalAlign: "top",
                    }}
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          </>
        ) : (
          ""
        )}
        <div className="author__info ">
          <div className="d-flex flex-wrap align-items-center">
            {/* Author Name */}
            {headerOne?.includes("author") ? (
              <Tooltip title={cardData?.Author}>
                <div
                  className={
                    cardData?.isMenstionCountBlock
                      ? "author__info--name text-left menstion-title-text w-100 line-height-normal"
                      : "author__info--name text-ellipsis line-height-normal"
                  }
                >
                  {cardData?.Author}
                </div>
              </Tooltip>
            ) : (
              ""
            )}

            {/* Author is verified */}
            {headerOne?.includes("isverified") ? (
              <>
                {cardData?.isVerified !== "NA" &&
                cardData?.isVerified &&
                (cardData?.isVerified === "Verified" ||
                  cardData?.isVerified > 0) ? (
                  <img
                    src={verified}
                    alt="verified"
                    className="verified profileImg ml-1"
                    style={{ height: "1.6rem" }}
                  />
                ) : (
                  ""
                )}
              </>
            ) : (
              ""
            )}

            {/* Promoted post */}
            {headerOne?.includes("ispromoted") ? (
              <>
                {cardData?.isPromoted === 1 ? (
                  <Tooltip title="Boosted post">
                    <img
                      alt="Boosted Post Icon"
                      src={BoostedPostIcon}
                      className="mr-0"
                      style={{
                        width: "2rem",
                        height: "2rem",
                      }}
                    />
                  </Tooltip>
                ) : cardData?.isPromoted === 2 || cardData?.isPromoted === 5 ? (
                  <Tooltip
                    title={
                      cardData?.isPromoted === 5 ? "Dark Ad Post" : "Ad Post"
                    }
                  >
                    <img
                      alt="Ad Post Icon"
                      src={AdsPostIcon}
                      className="mr-0"
                      style={{
                        width: "2rem",
                        height: "2rem",
                      }}
                    />
                  </Tooltip>
                ) : (
                  ""
                )}
              </>
            ) : (
              ""
            )}
          </div>
          <div className="d-flex flex-wrap align-items-center">
            {/* Author Screen Name */}
            {headerOne?.includes("authorscreenname") ? (
              <>
                {cardData?.AuthorScreenName &&
                cardData?.PlatformID !== 2 &&
                cardData?.PlatformID !== 5 ? (
                  <div
                    className="author__info--screenName text-ellipsis w-100"
                    //style={{ width: "90%" }}
                  >
                    <Tooltip title={cardData?.AuthorScreenName}>
                      {cardData?.AuthorScreenName}
                    </Tooltip>
                  </div>
                ) : (
                  ""
                )}
              </>
            ) : headerOne?.includes("screenname") ? (
              <>
                {cardData?.ScreenName &&
                cardData?.PlatformID !== 2 &&
                cardData?.PlatformID !== 5 ? (
                  <div
                    className="author__info--screenName text-ellipsis w-100"
                    //style={{ width: "90%" }}
                  >
                    <Tooltip title={cardData?.ScreenName}>
                      {cardData?.ScreenName}
                    </Tooltip>
                  </div>
                ) : (
                  ""
                )}
              </>
            ) : (
              ""
            )}
          </div>
        </div>
        {/* Followers Count */}

        {headerTwo?.includes("followerscount") ? (
          <div className="d-flex flex-direction-column align-items-start text-ellipsis w-100 pl-15 pr-15 border-color border-left">
            {/* <img
                src={FollowersImage}
                alt="Followers Image"
                className="profileImg mr-1"
                style={{ height: "1.6rem" }}
              /> */}
            <div className="gallarycard__header--secondary-label">
              Followers{" "}
            </div>
            <div className="gallarycard__header--primary-content">
              <Tooltip title={cardData?.FollowersCount?.toLocaleString()}>
                {cardData?.FollowersCount?.toLocaleString()}
              </Tooltip>
            </div>
          </div>
        ) : (
          ""
        )}

        {/* Bio */}
        {headerTwo?.includes("bio") ? (
          <div className="gallarycard__header--bio d-flex flex-direction-column align-items-start  w-100  pl-15 pr-15 border-color border-left">
            {/* <img
                src={FollowersImage}
                alt="Followers Image"
                className="profileImg mr-1"
                style={{ height: "1.6rem" }}
              /> */}
            <div className="gallarycard__header--secondary-label">Bio </div>

            <div className="gallarycard__header--primary-content text-primary-color">
              {(cardData?.AuthorBio &&
                cardData?.AuthorBio !== "NA" &&
                cardData?.AuthorBio !== "") ||
              (cardData?.bio &&
                cardData?.bio !== "NA" &&
                cardData?.bio !== "") ? (
                <Tooltip
                  title={
                    cardData?.AuthorBio ? cardData?.AuthorBio : cardData?.bio
                  }
                >
                  <span className="bio__content">
                    {cardData?.AuthorBio ? cardData?.AuthorBio : cardData?.bio}
                  </span>
                </Tooltip>
              ) : (
                "Bio not found"
              )}
            </div>
          </div>
        ) : (
          ""
        )}
        {/* interactio with brand and trends */}
        {headerThree?.includes("interaction") ? (
          <div className="d-flex align-items-center justify-content-between text-ellipsis w-100  pl-15 pr-0 border-color border-left">
            <div className="d-flex flex-direction-column align-items-start">
              <div className="gallarycard__header--secondary-label">
                Interactions with Brand{" "}
              </div>

              <div className="d-flex align-items-center gallarycard__header--primary-content">
                <Tooltip
                  title={
                    cardData?.Interaction
                      ? cardData?.Interaction?.toLocaleString()
                      : ""
                  }
                >
                  {cardData?.Interaction
                    ? cardData?.Interaction?.toLocaleString()
                    : "NA"}
                </Tooltip>
              </div>
            </div>

            {isDetailView ? (
              ""
            ) : headerThree?.includes("trends") ? (
              <div
                className={`gallarycard__header--treandicon ${"cursor-pointer"}`}
                onClick={() => handleTrends(cardData)}
              >
                <Tooltip
                  title={
                    personalizationSettingsObj?.isPersonalizationPreviewOpen
                      ? "Actions are not allowed while customizing"
                      : "Open Trends"
                  }
                >
                  <img
                    src={TreandsPieIcon}
                    alt="Open Trends"
                    className=" profileImg img-responsive"
                  />
                </Tooltip>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};
export default React.memo(Header, isEqual);
